class LqdButtonHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.handleDestroy();

    this.initLocalScroll();
    this.initSplitText();

  }

  getDefaultSettings() {
    return {
      selectors: {
        localScrollElement: '[data-localscroll]',
        splitTextElement: '[data-split-text]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $localScrollElement: this.$element.find(selectors.localScrollElement),
      $splitTextElement: this.$element.find(selectors.splitTextElement),
    }
  }

  initLocalScroll() {

    this.elements.$localScrollElement.liquidLocalScroll();

  }

  initSplitText() {

    this.elements.$splitTextElement.liquidSplitText();

  }

  onDestroy() {

    this.handleDestroy();

    super.onDestroy();

  }

  handleDestroy() {

    this.handleSplitTextDestroy();

  }

  handleSplitTextDestroy() {

    if ( ! this.elements.$splitTextElement.length ) return;

    const splitTextData = this.elements.$splitTextElement.data('plugin_liquidSplitText');

    if ( splitTextData ) {
      splitTextData.destroy();
    }

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdButtonHandler, { $element } );
};